export default class StateMachine {
    constructor() {
        this.reset();
    }
    /**
     * Reset all states
     */
    reset() {
        this._mode = undefined;
        this._screen = undefined;
        this._hideIcons = false;
        this._botConnected = false;
        this._botWasConnected = false;
        this._agentConnected = false;
        this._loginNotice = false;
        this._feedbackOfferLocal = true;
        this._feedbackOfferGlobal = false;
        this._handoverAvailable = false;
        this._handoverStatusRequestFinished = false;
        this._uploadFileEnabled = false;
        this._tracked = {};
        this._screenProperties = {};
    }
    /**
     * Only states relevant to a chat session will be resetted
     */
    softReset() {
        this._screen = undefined;
        this._botConnected = false;
        this._botWasConnected = false;
        this._agentConnected = false;
        this._loginNotice = false;
        this._feedbackOfferLocal = true;
        this._feedbackOfferGlobal = false;
        this._handoverAvailable = false;
        this._handoverStatusRequestFinished = false;
        this._tracked = {};
        this._screenProperties = {};
    }
    /**
    * Mode that the widget is operating in.
    *
    * Currently supported modes:
    *
    *  "sticky" - widget is available on the page via a sticky avatar
    *
    *  "button" - widget is available on the page via a button activation
    */
    get mode() {
        return this._mode;
    }
    set mode(mode) {
        this._mode = mode;
    }
    /**
     * Screen that the widget is showing.
     *
     * Currently supported screens:
     *
     * "login" - login form screen
     *
     * "splash" - splash screen for anonym login
     *
     * "chat" - basic chatting screen
     *
     * "waiting" - agent waiting screen
     *
     * "gdpr" - gdpr screen
     */
    get screen() {
        return this._screen;
    }
    set screen(screen) {
        this._screen = screen;
    }
    /**
     * Hide icons in the header
     */
    get hideIcons() {
        return this._hideIcons;
    }
    set hideIcons(hideIcons) {
        this._hideIcons = hideIcons;
    }
    /**
     * Indicates that a bot is connected to the chat session
     */
    get botConnected() {
        return this._botConnected;
    }
    set botConnected(botConnected) {
        this._botConnected = botConnected;
        if (botConnected) {
            this._botWasConnected = true;
        }
    }
    /**
     * Flag that shows if bot was connected in the session
     */
    get botWasConnected() {
        return this._botWasConnected;
    }
    /**
     * Saves information about events that were tracked
     */
    get tracked() {
        return this._tracked;
    }
    /**
     * Indicates that any agent (includes bot) is connected to the chat session
     */
    get agentConnected() {
        return this._agentConnected;
    }
    set agentConnected(agentConnected) {
        this._agentConnected = agentConnected;
    }
    /**
     * Flag that sends on restore login notice
     */
    get loginNotice() {
        return this._loginNotice;
    }
    set loginNotice(loginNotice) {
        this._loginNotice = loginNotice;
    }
    /**
     * If false feedback offer will not be shown until the user sends a new message
     */
    get feedbackOfferLocal() {
        return this._feedbackOfferLocal;
    }
    set feedbackOfferLocal(feedbackOfferLocal) {
        this._feedbackOfferLocal = feedbackOfferLocal;
    }
    /**
     * If false feedback offer will not be shown
     */
    get feedbackOfferGlobal() {
        return this._feedbackOfferGlobal;
    }
    set feedbackOfferGlobal(feedbackOfferGlobal) {
        this._feedbackOfferGlobal = feedbackOfferGlobal;
    }
    /**
     * True if an agent is available for the topic
     */
    get handoverAvailable() {
        return this._handoverAvailable;
    }
    set handoverAvailable(handoverAvailable) {
        this._handoverAvailable = handoverAvailable;
    }
    /**
     * True if handover status request finished
     */
    get uploadFileEnabled() {
        return this._uploadFileEnabled;
    }
    set uploadFileEnabled(enable) {
        this._uploadFileEnabled = enable;
    }
    /**
     * True if file upload is enabled
     */
    get handoverStatusRequestFinished() {
        return this._handoverStatusRequestFinished;
    }
    set handoverStatusRequestFinished(finished) {
        this._handoverStatusRequestFinished = finished;
    }
    /**
     * Get cached properties for a ceratin screen
     *
     * @param screenName key for screen to get properties from
     */
    getScreenProperties(screenName) {
        if (screenName in this._screenProperties) {
            return this._screenProperties[screenName];
        }
        else {
            return {};
        }
    }
    /**
     * Set the value for a property for a specific screen
     *
     * @param screenName key to property object
     * @param property key for property to change
     * @param value to change the property to
     */
    setScreenProperty(screenName, property, value) {
        if (!this._screenProperties[screenName]) {
            this._screenProperties[screenName] = {};
        }
        this._screenProperties[screenName][property] = value;
    }
}
